import { useTranslation } from "react-i18next";
import {
	Checkbox,
	Select,
	MenuItem,
	ListSubheader,
	ListItemText,
	FormControl,
	InputLabel,
} from "@mui/material";

const KeySelector = (props) => {
	const { keys, onChange, onClose } = props;

	const { t } = useTranslation();

	return (
		<FormControl
			sx={{ minWidth: 120 }}
			size="small"
		>
			<Select
				value={[""]}
				multiple
				renderValue={(value) => t("Data")}
				onClose={() => onClose()}
			>
				<MenuItem>
					<Checkbox
						checked={keys.consumption_profile}
						onChange={(event) => {
							onChange({ ...keys, consumption_profile: event.target.checked });
						}}
					/>
					<ListItemText primary={t("Consumption and generation")} />
				</MenuItem>
				<MenuItem>
					<Checkbox
						checked={keys.realized}
						onChange={(event) => {
							onChange({ ...keys, realized: event.target.checked });
						}}
					/>
					<ListItemText primary={t("Realized consumption and generation")} />
				</MenuItem>
				<MenuItem>
					<Checkbox
						checked={keys.realized_savings}
						onChange={(event) => {
							onChange({ ...keys, realized_savings: event.target.checked });
						}}
					/>
					<ListItemText primary={t("Realized savings")} />
				</MenuItem>
				<MenuItem>
					<Checkbox
						checked={keys.electricity_consumption}
						onChange={(event) => {
							onChange({
								...keys,
								electricity_consumption: event.target.checked,
							});
						}}
					/>
					<ListItemText primary={t("Electricity consumption")} />
				</MenuItem>
				<MenuItem>
					<Checkbox
						checked={keys.cogeneration}
						onChange={(event) => {
							onChange({ ...keys, cogeneration: event.target.checked });
						}}
					/>
					<ListItemText primary={t("Cogeneration")} />
				</MenuItem>
				<MenuItem>
					<Checkbox
						checked={keys.solar_production}
						onChange={(event) => {
							onChange({
								...keys,
								solar_production: event.target.checked,
								direct_irradiance: event.target.checked,
								outside_temp: event.target.checked,
							});
						}}
					/>
					<ListItemText primary={t("Solar production")} />
				</MenuItem>
				<MenuItem>
					<Checkbox
						checked={keys.efficiency}
						onChange={(event) => {
							onChange({ ...keys, efficiency: event.target.checked });
						}}
					/>
					<ListItemText primary={t("Efficiency")} />
				</MenuItem>
				<MenuItem>
					<Checkbox
						checked={keys.transformer}
						onChange={(event) => {
							onChange({ ...keys, transformer: event.target.checked });
						}}
					/>
					<ListItemText primary={t("Transformers")} />
				</MenuItem>
				<MenuItem>
					<Checkbox
						checked={keys.energy_price}
						onChange={(event) => {
							onChange({ ...keys, energy_price: event.target.checked });
						}}
					/>
					<ListItemText primary={t("keyEnergyPrice")} />
				</MenuItem>
				<MenuItem>
					<Checkbox
						checked={keys.carbon_intensity}
						onChange={(event) => {
							onChange({ ...keys, carbon_intensity: event.target.checked });
						}}
					/>
					<ListItemText primary={t("CarbonIntensity")} />
				</MenuItem>
				<MenuItem>
					<Checkbox
						checked={keys.power_meter}
						onChange={(event) => {
							onChange({ ...keys, power_meter: event.target.checked });
						}}
					/>
					<ListItemText primary={t("Electricity meter")} />
				</MenuItem>
				<MenuItem>
					<Checkbox
						checked={keys.gas_meter}
						onChange={(event) => {
							onChange({ ...keys, gas_meter: event.target.checked });
						}}
					/>
					<ListItemText primary={t("Gas meter")} />
				</MenuItem>
			</Select>
		</FormControl>
	);
};

export default KeySelector;
